import { render, staticRenderFns } from "./baropen.vue?vue&type=template&id=b5fd097c&"
import script from "./baropen.vue?vue&type=script&lang=js&"
export * from "./baropen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports